module.exports = __webpack_public_path__ + "img/equipment_report.236376cb.png";